<div [formGroup]="form" class="container-fluid mt-4 px-0">
  <div class="row g-3">
    <div class="col-md-6">
      <app-case-form-section-container [iconClass]="'bi bi-question-circle'"
        [rightIconClass]="isAdmin ? 'bi bi-pencil' : ''" [title]="'label.need_help'"
        (onClickRightIcon)="toggleEditing('needHelpContent')">
        <div [ngClass]="{'view-mode': !isEditable['needHelpContent']}">
          <app-rich-text-editor
          formControlName="needHelpContent"
          [readonly]="!isEditable['needHelpContent']"
          [editableInline]="false"
        >
        </app-rich-text-editor>
        </div>
        <div *ngIf="isEditable['needHelpContent']" class="edit-actions">
          <button class="btn btn-success btn-sm" (click)="saveChanges('needHelpContent')">{{ 'buttons.save' | translate }}</button>
          <button class="btn btn-danger btn-sm" (click)="cancelChanges('needHelpContent')">{{ 'buttons.cancel' | translate }}</button>
        </div>
      </app-case-form-section-container>
    </div>

    <div class="col-md-6">
      <app-case-form-section-container [iconClass]="'bi bi-plus'" [rightIconClass]="isAdmin ? 'bi bi-pencil' : ''"
        [title]="'label.new_customer_site'" (onClickRightIcon)="toggleEditing('newCustomerSiteContent')">
        <div [ngClass]="{'view-mode': !isEditable['newCustomerSiteContent']}">
          <app-rich-text-editor
          formControlName="newCustomerSiteContent"
          [readonly]="!isEditable['newCustomerSiteContent']"
          [editableInline]="false"
        >
        </app-rich-text-editor>
        </div>
        <div *ngIf="isEditable['newCustomerSiteContent']" class="edit-actions">
          <button class="btn btn-success btn-sm" (click)="saveChanges('newCustomerSiteContent')">{{ 'buttons.save' | translate }}</button>
          <button class="btn btn-danger btn-sm" (click)="cancelChanges('newCustomerSiteContent')">{{ 'buttons.cancel' | translate }}</button>
        </div>
      </app-case-form-section-container>
    </div>
  </div>
</div>
